(function () {
    "use strict";

    // 1. Service Worker Registration
    if ('serviceWorker' in navigator && typeof NS_OBJ !== 'undefined' && NS_OBJ.service_worker) {
        navigator.serviceWorker.register(NS_OBJ.service_worker).catch(function (err) {
            console.warn('[PWA] Service Worker registration failed:', err);
        });
    }

    const pwaSettings = (typeof NS_OBJ !== 'undefined' && NS_OBJ.pwa_settings) ? NS_OBJ.pwa_settings : {};
    const i18n = pwaSettings.i18n || {
        install: 'نصب اپلیکیشن',
        close: 'بستن',
        offline_notice: 'ارتباط اینترنت شما قطع شد.',
        online_notice: 'ارتباط اینترنت مجدداً برقرار شد.',
        ios_share_step: '۱. دکمه اشتراک‌گذاری (Share) را لمس کنید',
        ios_add_step: '۲. گزینه «افزودن به صفحه اصلی» (Add to Home Screen) را انتخاب کنید'
    };

    let deferredPrompt = null;

    // Helper: Check if user dismissed prompt recently
    const isDismissed = () => {
        const until = localStorage.getItem('ns_pwa_dismissed_until');
        if (!until) return false;
        return Date.now() < parseInt(until, 10);
    };

    // Helper: Store dismissal timestamp
    const setDismissed = (days) => {
        const dismissDays = parseInt(days || 7, 10);
        const until = Date.now() + dismissDays * 24 * 60 * 60 * 1000;
        localStorage.setItem('ns_pwa_dismissed_until', until.toString());
    };

    // Helper: Check if running in Standalone mode
    const isInStandaloneMode = () =>
        (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone === true) || document.referrer.includes('android-app://');

    // Helper: Check if running on mobile/tablet device
    const isMobileDevice = () =>
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 991;

    // 2. Install Prompt Renderer
    const renderInstallPrompt = () => {
        if (isInStandaloneMode() || isDismissed() || pwaSettings.prompt_status === 'false') {
            return;
        }

        if (pwaSettings.prompt_mobile_only !== 'false' && !isMobileDevice()) {
            return;
        }

        const mode = pwaSettings.prompt_mode || 'banner_bottom';
        const title = pwaSettings.prompt_title || 'نصب اپلیکیشن نگارشاپ';
        const desc = pwaSettings.prompt_desc || 'برای دسترسی سریع‌تر و استفاده بدون اینترنت، اپلیکیشن را نصب کنید.';
        const btnText = pwaSettings.prompt_btn || 'نصب اپلیکیشن';
        const iconUrl = pwaSettings.app_icon || '';

        let container = null;

        if (mode === 'modal') {
            const backdrop = document.createElement('div');
            backdrop.className = 'ns-pwa-prompt-modal-backdrop';
            backdrop.innerHTML = `
                <div class="ns-pwa-prompt-modal">
                    ${iconUrl ? `<div class="ns-pwa-icon-wrap"><img src="${iconUrl}" alt="${title}"></div>` : ''}
                    <div class="ns-pwa-title">${title}</div>
                    <div class="ns-pwa-desc">${desc}</div>
                    <div class="ns-pwa-modal-actions">
                        <button class="button button-primary ns-pwa-install-btn">${btnText}</button>
                        <button class="ns-pwa-dismiss-btn">${i18n.close}</button>
                    </div>
                </div>
            `;
            document.body.appendChild(backdrop);

            backdrop.querySelector('.ns-pwa-install-btn').addEventListener('click', triggerInstall);
            backdrop.querySelector('.ns-pwa-dismiss-btn').addEventListener('click', () => {
                backdrop.classList.add('ns-pwa-hide');
                setDismissed(pwaSettings.prompt_dismiss);
            });
            container = backdrop;
        } else if (mode === 'bar_top') {
            const bar = document.createElement('div');
            bar.className = 'ns-pwa-prompt-bar';
            bar.innerHTML = `
                <div class="ns-pwa-bar-left">
                    ${iconUrl ? `<img src="${iconUrl}" alt="${title}">` : ''}
                    <span><strong>${title}</strong> — ${desc}</span>
                </div>
                <div class="ns-pwa-bar-right">
                    <button class="button button-primary ns-pwa-install-btn">${btnText}</button>
                    <button class="ns-pwa-close-btn" aria-label="${i18n.close}">✕</button>
                </div>
            `;
            document.body.prepend(bar);

            bar.querySelector('.ns-pwa-install-btn').addEventListener('click', triggerInstall);
            bar.querySelector('.ns-pwa-close-btn').addEventListener('click', () => {
                bar.classList.add('ns-pwa-hide');
                setDismissed(pwaSettings.prompt_dismiss);
            });
            container = bar;
        } else {
            // Default: Bottom Banner
            const banner = document.createElement('div');
            banner.className = 'ns-pwa-prompt-banner';
            banner.innerHTML = `
                ${iconUrl ? `<div class="ns-pwa-icon-wrap"><img src="${iconUrl}" alt="${title}"></div>` : ''}
                <div class="ns-pwa-content">
                    <div class="ns-pwa-title">${title}</div>
                    <div class="ns-pwa-desc">${desc}</div>
                </div>
                <div class="ns-pwa-actions">
                    <button class="button button-primary ns-pwa-install-btn">${btnText}</button>
                    <button class="ns-pwa-close-btn" aria-label="${i18n.close}">✕</button>
                </div>
            `;
            document.body.appendChild(banner);

            banner.querySelector('.ns-pwa-install-btn').addEventListener('click', triggerInstall);
            banner.querySelector('.ns-pwa-close-btn').addEventListener('click', () => {
                banner.classList.add('ns-pwa-hide');
                setDismissed(pwaSettings.prompt_dismiss);
            });
            container = banner;
        }
    };

    const triggerInstall = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            console.log('[PWA] User accepted the install prompt');
        } else {
            setDismissed(pwaSettings.prompt_dismiss);
        }
        deferredPrompt = null;

        const promptEls = document.querySelectorAll('.ns-pwa-prompt-banner, .ns-pwa-prompt-modal-backdrop, .ns-pwa-prompt-bar');
        promptEls.forEach(el => el.classList.add('ns-pwa-hide'));
    };

    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt = e;
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', renderInstallPrompt);
        } else {
            renderInstallPrompt();
        }
    });

    // 3. iOS Safari Custom Guidance Prompt
    const checkIosInstallGuide = () => {
        const isIos = /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(navigator.userAgent);

        if (isIos && isSafari && !isInStandaloneMode() && !isDismissed() && pwaSettings.prompt_status !== 'false' && pwaSettings.ios_guide !== 'false') {
            const guide = document.createElement('div');
            guide.className = 'ns-pwa-ios-guide';
            guide.innerHTML = `
                <div class="ns-pwa-ios-header">
                    <span class="ns-pwa-ios-title">${pwaSettings.prompt_title || 'نصب اپلیکیشن نگارشاپ'}</span>
                    <button class="ns-pwa-close-btn" aria-label="${i18n.close}">✕</button>
                </div>
                <div class="ns-pwa-ios-steps">
                    <div class="ns-pwa-ios-step">
                        <i class="fi fi-rr-share"></i>
                        <span>${i18n.ios_share_step}</span>
                    </div>
                    <div class="ns-pwa-ios-step">
                        <i class="fi fi-rr-plus-square"></i>
                        <span>${i18n.ios_add_step}</span>
                    </div>
                </div>
                <div class="ns-pwa-ios-arrow"></div>
            `;
            document.body.appendChild(guide);

            guide.querySelector('.ns-pwa-close-btn').addEventListener('click', () => {
                guide.classList.add('ns-pwa-hide');
                setDismissed(pwaSettings.prompt_dismiss);
            });
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkIosInstallGuide);
    } else {
        checkIosInstallGuide();
    }

    // 4. Offline / Online Toast Notification
    if (pwaSettings.offline_indicator !== 'false') {
        const showToast = (message, type) => {
            const existing = document.querySelector('.ns-pwa-toast');
            if (existing) existing.remove();

            const toast = document.createElement('div');
            toast.className = `ns-pwa-toast ${type}`;
            toast.innerHTML = `<span>${message}</span>`;
            document.body.appendChild(toast);

            if (type === 'online') {
                setTimeout(() => {
                    toast.classList.add('fade-out');
                    setTimeout(() => toast.remove(), 300);
                }, 3000);
            }
        };

        window.addEventListener('offline', () => showToast(i18n.offline_notice, 'offline'));
        window.addEventListener('online', () => showToast(i18n.online_notice, 'online'));
    }

    // 5. Standalone Loader Transition
    if (isInStandaloneMode()) {
        const showLoader = () => {
            const loader = document.createElement('div');
            loader.className = 'pwa-page-loader';
            loader.innerHTML = '<span class="spinner"></span>';
            document.body.insertBefore(loader, document.body.firstChild);
            setTimeout(function () {
                loader.remove();
            }, 8000);
            return loader;
        };

        let activeLoader = showLoader();

        const removeLoader = () => {
            if (activeLoader) {
                activeLoader.remove();
                activeLoader = null;
            }
            const loaderEl = document.querySelector('.pwa-page-loader');
            if (loaderEl) {
                loaderEl.remove();
            }
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', removeLoader);
        } else {
            removeLoader();
        }

        window.addEventListener('beforeunload', () => {
            activeLoader = showLoader();
        });
    }
})();
